module.exports = __webpack_public_path__ + "static/building-a-brotherhood-0554526cca1d49065a0bf205f6eda382.jpg";